import {
  isRiskAssessmentHeaderOnlySection,
  type RiskAssessmentSectionRecord,
} from '@artem-lex/compliance-documents'

export function shouldShowRiskAssessmentSectionEditor(
  section: RiskAssessmentSectionRecord
): boolean {
  return !isRiskAssessmentHeaderOnlySection(section.sectionId)
}
